export interface Condition {
  id: string;
  seriesId: string;
  field: string;
  comparator: string;
  value: number;
}

export interface ConditionGroup {
  id: string;
  operator: 'AND' | 'OR';
  children: (Condition | ConditionGroup)[];
}

export interface TradeAction {
  id: string;
  action: 'buy' | 'sell';
  volume: number;
  symbol: string;
}

export interface TradeRule {
  id: string;
  timestamp: string;
  eventId?: string;
  eventName?: string;
  eventCountry?: string;
  actions: TradeAction[];
  rootGroup: ConditionGroup;
}

export interface SerializedCondition {
  sid: string;
  cmp: string;
  val: number | string;
}

export interface SerializedGroup {
  op: 'AND' | 'OR';
  conds: Array<SerializedGroup | SerializedCondition>;
}

export interface TradeRules {
  rules: {
    ts: number;
    acts: { act: string; vol: number; sym: string }[];
    g: SerializedGroup;
  }[];
}

export type SeriesOption = {
  dataSeriesId: number;
  display: string;
};

export function isGroup(child: Condition | ConditionGroup): child is ConditionGroup {
  return 'operator' in child && 'children' in child;
}
